import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuardService } from './core/services/auth-guard.service';
import { CopMainComponent } from './modules/cop/cop-main/cop-main.component';
import { DnsConfigResolver } from './core/resolvers/dns-config.resolver';

const routes: Routes = [
    {
        path: '',
        component: CopMainComponent,
        children: [
            {
                path: 'auth',
                loadChildren: () => import('../app/modules/cop/cop-authentication/cop-authentication.module')
                .then(x => x.CopAuthenticationModule),
                resolve: {
                    theme: DnsConfigResolver
                }
            },
            {
                path: '',
                canActivate: [AuthGuardService],
                data: {
                    canActivateReturnUrl: 'auth',
                    permissions: [
                        'employee-perform-consultancy'
                    ]
                },
                loadChildren: () => import ('../app/modules/cop/cop-home/cop-home.module').then(x => x.CopHomeModule),
                resolve: {
                    theme: DnsConfigResolver
                }
            },
            {
                path: 'helper',
                canActivate: [AuthGuardService],
                data: {
                    canActivateReturnUrl: 'auth'
                },
                loadChildren: () => import ('../app/modules/cop/cop-helper/cop-helper.module').then(x => x.CopHelperModule),
                resolve: {
                    theme: DnsConfigResolver
                }
            },
        ]
    },
    {
        path: 'no-responsive-support',
        loadChildren: () => import('./shared/components/no-responsive-support/no-responsive-support.module')
        .then(x => x.NoResponsiveSupportModule)
    },
    {path: '**', redirectTo: '', pathMatch: 'full'}
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule]
})
export class AppRoutingModule {
}
